function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    width: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "c delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.5,
    style: {
      stroke: "rgb(255, 255, 255)",
      strokeOpacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 9,
    y2: 6,
    style: {
      stroke: "rgb(255, 255, 255)",
      strokeOpacity: 0.75
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCDelete);
export default __webpack_public_path__ + "static/media/c-delete.be8d87effa7c53b4a714b9b30792c06e.svg";
export { ForwardRef as ReactComponent };